module.exports = __webpack_public_path__ + "static/logo-hover-da0fd626dbf16d9a025060680f4ad273.svg";